// Slab CGC Cards 1:1: holder oficial 3,15 × 5,30 in (80,0 × 134,6 mm); janela da etiqueta 5 mm
// abaixo do topo; carta 63 × 88 mm centralizada e ancorada 3,5 mm do fundo (medidas da foto do
// holder). A fonte canônica é `geometry.slab` do backend (GET /admin/art-labels/geometry);
// SLAB_MM é só o fallback. O G1 (fornecedor) troca estes números num lugar só.
export const SLAB_MM = {
  width: 80,
  height: 134.6,
  cornerRadius: 4.5,
  labelTop: 5,
  cardBottomMargin: 3.5,
  wellInset: 1.5, // folga do poço em volta da janela da etiqueta
  wallMin: 1.2, // parede mínima do acrílico de cada lado do poço
  cardWidth: 63,
  cardHeight: 88,
};

/**
 * Caixas em px do preview do slab para um fator px/mm: `width`/`height`/`radius` do corpo,
 * `well` (poço rebaixado que abriga etiqueta e carta), `label` (janela da frente,
 * labelWidth × frontHeight) e `card` (carta ancorada no fundo). `geometry.slab` (backend)
 * sobrescreve o SLAB_MM.
 */
export function slabPreviewLayout(geometry, pxPerMm) {
  const g = geometry;
  const S = { ...SLAB_MM, ...(g.slab || {}) };
  const mm = (v) => v * pxPerMm;
  const label = {
    left: mm((S.width - g.labelWidth) / 2),
    top: mm(S.labelTop),
    width: mm(g.labelWidth),
    height: mm(g.frontHeight),
  };
  const card = {
    left: mm((S.width - S.cardWidth) / 2),
    top: mm(S.height - S.cardBottomMargin - S.cardHeight),
    width: mm(S.cardWidth),
    height: mm(S.cardHeight),
  };
  // o poço nunca passa da parede mínima: uma etiqueta mais larga que o slab é problema do G1, não do preview
  const wellWidth = Math.min(Math.max(g.labelWidth, S.cardWidth) + 2 * S.wellInset, S.width - 2 * S.wallMin);
  const well = {
    left: mm((S.width - wellWidth) / 2),
    top: mm(S.labelTop - S.wellInset),
    width: mm(wellWidth),
    height: mm(S.height - S.cardBottomMargin + S.wellInset - (S.labelTop - S.wellInset)),
  };
  return { width: mm(S.width), height: mm(S.height), radius: mm(S.cornerRadius), well, label, card };
}
